import React, { useEffect, useState } from 'react';
import {
  AccordianContentCarousel,
  AccordianTitleInner,
  AccordionContent,
  AccordionItem,
  AccordionTitle,
  AccordionWrapper,
} from './styled';
import { getScreenName } from '../../../Utils/helper';
import Image from 'next/image';
import { images } from '../../../Constants/ImageUrls';
import OvulationCalculatorBox from '../../OvulationTool/OvulationCalculatorBox';
import { fireEvent } from '../../../Utils/fireEvent';

export default function UniversalAccordion(props) {
  const { categoryAccordionData, faq } = props;
  const [activeIndex, setActiveIndex] = useState(4);
  const sectionName = faq ? 'Collapsible Section faq' : 'Collapsible Section';

  const onTitleClick = (index, active, data) => {
    if (active) {
      setActiveIndex(null);
    } else {
      setActiveIndex(index);
    }
    fireEvent({
      category: 'clicked_cta',
      screen_name: getScreenName(),
      cta: active ? '-' : '+',
      page_url: window.location.href,
      section_name: sectionName,
      collapsible_title: data.title,
    });
  };

  useEffect(() => {
    fireEvent({
      category: 'served_section_in_myloshop',
      screen_name: getScreenName(),
      section_id: '',
      section_name: sectionName,
      shape: 'Collapsible',
      page_url: window.location.href.slice(0, 99),
    });
  }, []);

  const renderedAccordion = categoryAccordionData?.map((data, index) => {
    const active = index === activeIndex ? true : false;

    return (
      <AccordionItem faq={faq} key={index} active={active}>
        <AccordionTitle onClick={() => onTitleClick(index, active, data)}>
          <AccordianTitleInner>
            {data.title}{' '}
            {data?.titleHypText && (
              <a
                href={data?.deeplink}
                target="_blank"
                rel="noreferrer noopener"
                onClick={(e) => e.stopPropagation()}
              >
                {data?.titleHypText}
              </a>
            )}
          </AccordianTitleInner>

          {!active ? (
            <Image
              src={images.plusBlack}
              alt="plus icon"
              width={24}
              height={24}
              quality={90}
            />
          ) : (
            <Image
              src={images.minusSvg}
              alt="minus icon"
              width={24}
              height={24}
              quality={90}
            />
          )}
        </AccordionTitle>
        {data?.carouselImages?.length ? (
          <AccordianContentCarousel className={active ? 'extendHeight' : ''}>
            {data.carouselImages.map((item, index) => (
              <div key={index}>
                <img src={item} alt="" />
              </div>
            ))}
          </AccordianContentCarousel>
        ) : (
          <AccordionContent
            tool={data?.showTool}
            className={active ? 'extendHeight' : ''}
          >
            {data?.text && (
              <div>
                <div
                  dangerouslySetInnerHTML={{
                    __html: data.text,
                  }}
                ></div>{' '}
                {data?.hypText && (
                  <a
                    href={data?.deeplink}
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    {data?.hypText}
                  </a>
                )}
              </div>
            )}
            {data?.contentBullet && (
              <ul>
                {data?.contentBullet?.map((txt, index) => (
                  <li key={'content' + index}>{txt}</li>
                ))}
              </ul>
            )}
            {data?.showTool ? (
              <OvulationCalculatorBox
                aplus={true}
                heading="OVULATION CALCULATOR"
                fromFaq={true}
              />
            ) : null}
          </AccordionContent>
        )}
      </AccordionItem>
    );
  });
  return <AccordionWrapper>{renderedAccordion}</AccordionWrapper>;
}
